import Vue from "vue";

[
  "RichTextEditor",
  "TextField",
  "TextArea",
  "RadioGroup",
  "Checkbox",
  "ColorPicker",
  "DateTimePicker",
  "FormBuilder",
  "Banner",
  "Uploader",
  "UploaderWithBgPosition",
  "Spinner",
  "Search",
  "ContextSearch",
  "Dropdown",
  "SubmitFooter",
  "IndexPageActions",
  "Pagination",
  "Stories",
  "Actions",
  "Slides",
  "Alert",
  "ConfirmDialog",
  "RecaptchaText",
  "ThemesTabs",
  "Avatar",
  "Switcher",
  "CodeEditor",
  "Addon",
  "SubmissionLayoutBuilder",
  "EnvSelectorDialog",
  "MetaTagsEditor",
  "UtmSourceGroupsEditor",
  "ThemeTemplate",
  "JsonViewer",
  "ImageCropper",
  "Notice",
].forEach((e) => {
  Vue.component(e, require(`./${e}.vue`).default);
});

[
  "TextBlock",
  "Countdown",
  "ContentSection",
  "Event",
  "List",
  "Schedule",
  "SupportForm",
  "SubmissionForm",
  "HtmlBlock",
  "SubmissionContent",
  "Presentation",
  "CustomComponent",
  "RegistrationForm",
  "VenueEventsList",
].forEach((e) => {
  Vue.component(`Page${e}`, require(`./page-components/${e}.vue`).default);
});

[
  "FormRow",
  "FormPanels",
  "FormPanel",
  "InheritedTextHint",
  "InheritedImageHint",
].forEach((e) => {
  Vue.component(e, require(`./form/${e}.vue`).default);
});

[
  "AddonEmailPasswordLogin",
  "AddonCasLogin",
  "AddonJustGiving",
  "AddonTwitterLogin",
  "AddonLinkedinLogin",
  "AddonFacebookLogin",
  "AddonGoogleLogin",
  "AddonVimeoUpload",
  "AddonYoutubeUpload",
  "AddonGa",
  "AddonPixel",
  "AddonTikTokPixel",
  "AddonGdpr",
  "AddonMailerlite",
  "AddonDropbox",
  "AddonGoogleDrive",
  "AddonTicketmaster",
  "AddonGreenhouse",
  "AddonCaptureJs",
  "AddonClarity",
].forEach((e) => {
  Vue.component(e, require(`./addon-forms/${e}.vue`).default);
});

["ListPanels", "ListPanel"].forEach((e) => {
  Vue.component(e, require(`./list/${e}.vue`).default);
});

[
  "Boolean",
  "DateTime",
  "HasMany",
  "HasOne",
  "Html",
  "Image",
  "MultiSelect",
  "MultiText",
  "Number",
  "PageSelect",
  "RichText",
  "Select",
  "TextArea",
  "TextField",
  "GreenhouseApplicationSelect",
].forEach((e) => {
  Vue.component(`SchemaField${e}`, require(`./schema/fields/${e}.vue`).default);
  Vue.component(
    `SchemaBuilder${e}`,
    require(`./schema/builder/${e}.vue`).default
  );
});

["RelationSelector"].forEach((e) => {
  Vue.component(`SchemaField${e}`, require(`./schema/fields/${e}.vue`).default);
});

Vue.component(
  "SchemaFieldVimeoVideo",
  require("./schema/fields/VimeoVideo.vue").default
);
Vue.component(
  "SchemaBuilderVimeoVideo",
  require("./schema/builder/VimeoVideo.vue").default
);

["Builder"].forEach((e) => {
  Vue.component(`Schema${e}`, require(`./schema/${e}.vue`).default);
});

[
  "BlogTagsSelector",
  "TimezoneSelector",
  "EnvSelector",
  "ThemesSelector",
  "SchedulesSelector",
  "TagSelector",
  "ListsSelector",
  "NotificationTypeSelector",
  "TextBlockLayoutSelector",
  "FontSelector",
  "Select",
  "EventsSelector",
  "PagesSelector",
  "GreenhouseJobPostsSelector",
  "RolesSelector",
  "ContentSectionsSelector",
  "ProjectSelector",
  "ProjectsSelector",
  "UsersSelector",
  "SubmissionFormSelector",
  "SubmissionContentLayoutSelector",
  "CustomComponentsSelector",
  "CustomComponentSelector",
  "TicketmasterVenueSelector",
  "VenueEventSelector",
].forEach((e) => {
  Vue.component(e, require(`./selects/${e}.vue`).default);
});

[
  "PresentationImage",
  "PresentationRotator",
  "PresentationVimeo",
  "PresentationYoutube",
].forEach((e) => {
  Vue.component(e, require(`./presentation/${e}.vue`).default);
});

[
  "TextField",
  "TextArea",
  "EmailField",
  "NumberField",
  "MediaField",
  "Checkbox",
  "Radio",
  "Select",
  "HtmlBlock",
  "PasswordField",
  "CustomComponent",
].forEach((e) => {
  Vue.component(
    `FormBuilder${e}`,
    require(`./form-builder/${e}.form-builder.vue`).default
  );
});

[
  "TextField",
  "TextArea",
  "EmailField",
  "NumberField",
  "MediaField",
  "Checkbox",
  "Radio",
  "HtmlBlock",
  "Select",
].forEach((e) => {
  Vue.component(
    `Dynamic${e}`,
    require(`./dynamic-inputs/${e}.dynamic.vue`).default
  );
});

["NextBtn", "BackBtn"].forEach((e) => {
  Vue.component(`Onboarding${e}`, require(`./onboarding/${e}.vue`).default);
});
